import React from "react";
import Navbar from "../component/Navbar";
import { HiCheckCircle } from "react-icons/hi";
import { Link } from "react-router-dom";

import Webimagefooter from "../component/Login/Webimagefooter";

const Changepasssuccess = () => {
  return (
    <div className="w-full bg-[radial-gradient(89.62%_213.03%_at_38.75%_80.3%,_#07031C_0%,_#241D4A_30.52%,_#07031C_64.32%)]">
      <Navbar />

      <div className=" w-full h-[800px]  md:h-[650px] grid place-items-center z-50 bg-transparent">
        <div className="  text-white rounded-lg shadow-lg p-8 max-w-sm w-full">
          <div className="px-4 py-4">
            <HiCheckCircle className="text-[#F2C493]  text-6xl mb-4" />
            <h1 className="text-3xl font-bold mb-4">
              Password Change Successfuly
            </h1>
            <p className="text-lg mb-8">
              Your account password been changed successfully!!
            </p>

            <Link
              to="/login"
              className="bg-[#D4F5F9] rounded-md px-6 py-3 text-black font-semibold"
            >
              Continue
            </Link>
          </div>
        </div>
      </div>

      <Webimagefooter />
    </div>
  );
};

export default Changepasssuccess;
